import { Injectable } from '@angular/core';
import { UserPermissionService } from '@app/shared/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { permissionStoreActions } from '.';
import { RootStoreState } from '..';
import * as loginSelectors from '../../root-store/login-store/login.selector';

@Injectable()
export class PermissionStoreEffects {
  user;
  subscription = new Subscription();

  constructor(
    public userPermissionService: UserPermissionService,
    private actions$: Actions,
    private store$: Store<RootStoreState.State>,
    private _store: Store
  ) {
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
        }
      })
    );
  }

  permissionsObject = this.store$.select('Permissions');

  getalreadpermissionapprovedList$ : Observable<any> = createEffect(() =>
  this.actions$.pipe(
    ofType<permissionStoreActions.alreadyPermissionsApprovedList>(permissionStoreActions.ActionTypes.ALREADY_PERMISSION_APPROVED_LIST),

    switchMap((action: any) => {
      return this.userPermissionService.getUserPermissionsRecivedAllAccedted().pipe(
        map((data) => {
          if (data) {
            let all_permissions = [];
            let permissions = [];
            all_permissions = permissions = [...data];
            permissions = permissions.sort(function (a, b) {
              if (a.user_first_middle_name < b.user_first_middle_name) {
                return -1;
              }
              if (a.user_first_middle_name > b.user_first_middle_name) {
                return 1;
              }
              return 0;
            });
            return new permissionStoreActions.alreadyPermissionsApprovedListComplete(permissions);
          }
        }),
        catchError((error) => {
          return of(new permissionStoreActions.alreadyPermissionsApprovedListFailure(error));
        })
      );
    })
  )
  );
}
